export default {
  provide () {
    return {
      $currency (number, prefix = '$') {
        if (!number) {
          return 0
        }

        //return `${prefix}${number.toString().replace(/(.)(?=(?:\d{3})+$)/g, '$1,').replace(/\.\d+/, '')}`

        // 使用 toLocaleString 自動處理千分位，並設定最大小數為 0
        return `${prefix}${Number(number).toLocaleString('zh-TW', { maximumFractionDigits: 0 })}`
      }
    }
  },
}
